import { Typography } from "antd";

const { Text } = Typography;

export const noWrapTextRender = (value: any, color?: any) => (
  <Text style={{ whiteSpace: "nowrap", color }}>{value}</Text>
);
